var dirStyleGenerator = function (key, value, defaultValue) {
    var _a;
    if (defaultValue === void 0) { defaultValue = undefined; }
    return (_a = {},
        _a["" + key + (key === '' ? 'r' : 'R') + "ight"] = function (_a) {
            var dir = _a.dir;
            return dir === 'ltr' ? value : defaultValue;
        },
        _a["" + key + (key === '' ? 'l' : 'L') + "eft"] = function (_a) {
            var dir = _a.dir;
            return dir === 'ltr' ? defaultValue : value;
        },
        _a);
};
export default dirStyleGenerator;
//# sourceMappingURL=dirStyleGenerator.js.map